export const GET_TERMS_CONDITIONS_REQUEST = 'termsConditionsReducer/GET_TERMS_CONDITIONS_REQUEST';
export const GET_TERMS_CONDITIONS_SUCCESS = 'termsConditionsReducer/GET_TERMS_CONDITIONS_SUCCESS';
export const GET_TERMS_CONDITIONS_FAILED = 'termsConditionsReducer/GET_TERMS_CONDITIONS_FAILED';